import { styled } from "styled-components";

import SectionTitle from "../atoms/SectionTitle";
import Section, { StyledSectionImage } from "../molecules/Section";

import { ReactComponent as AsteriskIcon } from "../../assets/icons/asterisk.svg";
import ContactImage from "../../assets/icons/contact.svg";

const Contact = () => {
  return (
    <Section id="contact">
      <SectionTitle title="contact" />
      <StyledSectionImage src={ContactImage} alt="" />

      <StyledFooter>
        <StyledSocials>
          <a
            href="https://www.linkedin.com/in/karol-gucwa-0a3104226/"
            target="_blank"
            rel="noreferrer"
          >
            <AsteriskIcon />
            linkedin
          </a>
          <a
            href="https://github.com/KarolG99"
            target="_blank"
            rel="noreferrer"
          >
            <AsteriskIcon />
            github
          </a>
          <a
            href="https://huggingface.co/GKarol"
            target="_blank"
            rel="noreferrer"
          >
            <AsteriskIcon />
            huggingface
          </a>
          <a
            href="https://www.kaggle.com/karolgu"
            target="_blank"
            rel="noreferrer"
          >
            <AsteriskIcon />
            kaggle
          </a>
        </StyledSocials>

        <StyledContactInfo>
          <a href="mailto:karolgucwav2@gmail.com">
            Email
            <br />
            <span>karolgucwav2@gmail.com</span>
          </a>
        </StyledContactInfo>
      </StyledFooter>
    </Section>
  );
};

const StyledFooter = styled.footer`
  margin-top: 58px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledSocials = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: wrap row;
  gap: 20px;
  width: 100%;
  max-width: 700px;
  a {
    font-size: 20px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primaryText};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    svg {
      margin-right: 5px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.highlightedText};
      bottom: 0;
      left: 0;
      transition: width 0.3s ease-in-out;
    }
    &:hover {
      &::after {
        width: 100%;
      }
    }

    @media (min-width: 600px) {
      font-size: 22px;
    }
  }
`;

const StyledContactInfo = styled.div`
  margin-top: 50px;
  a {
    font-size: 20px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primaryText};
    position: relative;
    span {
      color: ${({ theme }) => theme.colors.primaryText07};
      font-size: 18px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.highlightedText};
      bottom: 0;
      left: 0;
      transition: width 0.3s ease-in-out;
    }
    &:hover {
      &::after {
        width: 100%;
      }
    }

    @media (min-width: 600px) {
      font-size: 20px;
      span {
        font-size: 18px;
      }
    }
  }
`;

export default Contact;
